import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { complaintmodel } from "../../models/complaints/complaint-model";
//import { ComplaintInvoiceModel } from "../../models/complaints/complaint-invoice-model";
import { ComplaintInvoiceModel } from "../../models/complaints/complaint-model";
import ComplaintService from "../../services/complaint/ComplaintService";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import UpdateComplaintDataTable from "../Complaint/UpdateComplaintDataTable";
import { Toast } from "primereact/toast";
import ComplaintInvoice from "./ComplaintInvoice";

interface DataTableProps {
  data: any;
  handlepagechange: any;
  updatedData: any;
  pageNo: number;
  pageSize: number;
  complaintList: any;
  totalRecordsCount: number;
}

const ViewallComplaintsDatatable: React.FC<DataTableProps> = (props) => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [updateComplaintInfo, setUpdateComplaintInfo] = useState<complaintmodel>();
  const [complaints, setComplaints] = useState<complaintmodel[]>([]);
  const [showEditComplaintModal, setShowEditComplaintModal] = useState(false);
  const [allComplaints, setAllComplaints] = useState<any>();
  //const [selectedInvoice, setSelectedInvoice] = useState<ComplaintInvoiceModel | null>(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState<ComplaintInvoiceModel[] | null>(null);

  useEffect(() => {
    if (complaints.length > 0 && props.updatedData.length === undefined) {
      const db = [...complaints, props.updatedData];
      setComplaints(db);
    }
    setAllComplaints(props.data);
  }, [props.data, props.updatedData, complaints]);

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString();
  };

  const otherActionTemplate = (rowData: complaintmodel) => {
    return (
      <div className="flex">
        <Button
          icon="pi pi-pencil"
          onClick={() => {
            setUpdateComplaintInfo(rowData);
            setShowEditComplaintModal(true);
          }}
          style={{ border: "none", color: "gray", background: "none" }}
          className="p-button-rounded p-mr-2"
        />
      </div>
    );
  };

  const handleOnSuccess = () => {
    setShowEditComplaintModal(false);
    showToast("Update Complaint", "Complaint updated successfully", "success");
  };

  const showToast = (label: string, message: string, severity: 'success' | 'error' | 'info' | 'warn') => {
    toast.current?.show({ severity, summary: label, detail: message, life: 3000 });
  };

const handleInvoiceClick = async (rowData: complaintmodel) => {
  if (!rowData.invoiceNo) {
    showToast("Error", "No invoice number available", "error");
    return;
  }

  setLoadingInvoice(true);
  try {
    const invoiceDetails = await ComplaintService.InvoiceNumber(rowData.invoiceNo);
    console.log("Invoice Details:", invoiceDetails);

    if (invoiceDetails && Array.isArray(invoiceDetails) && invoiceDetails.length > 0) {
      setSelectedInvoice(invoiceDetails); 
      setShowInvoiceModal(true);
    } else {
      showToast("Error", "No invoice data found", "error");
    }
  } catch (error) {
    console.error("Error fetching invoice:", error);
    showToast("Error", "Failed to load invoice details", "error");
  } finally {
    setLoadingInvoice(false);
  }
};
  return (
    <div className="col-12">
      <Toast ref={toast} />
      <div className="card border-noround p-2">
       <DataTable
  value={allComplaints}
  paginator
  lazy
  rowsPerPageOptions={[5, 10, 25, 50, 100]}
  first={(props.pageNo - 1) * props.pageSize}
  totalRecords={props.totalRecordsCount}
  rows={props.pageSize}
  stripedRows
  onPage={props.handlepagechange}
  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
  currentPageReportTemplate={'{first} to {last} of {totalRecords}'}
  loading={loadingInvoice}
>
  <Column field="complaintId" header="Complaint ID" sortable/>
  <Column
    field="complaintDate"
    header={t("Complaint Date")}
    body={(rowData) => formatDate(rowData.complaintDate)}
    sortable
  />
  <Column
    field="invoiceNo"
    header={t("Invoice No")}
    sortable
    body={(rowData: complaintmodel) => (
      <Button
        link
        label={rowData.invoiceNo?.toString()}
        onClick={() => handleInvoiceClick(rowData)}
        className="p-0 text-primary font-bold"
      />
    )}
  />
  <Column field="productName" header={t("Product Name")} sortable/>
  <Column field="description" header={t("Description")} style={{ maxWidth: "350px", wordWrap: "break-word" }}/>
  <Column field="complaintCategory" header={t("Complaint Category")} sortable/>
  <Column field="complaintType" header={t("Complaint Type")} sortable/>
  <Column field="status" header={t("Status")} sortable/>
  <Column field="custName" header={t("User Name")} sortable/>
  <Column field="mobile" header={t("Primary Contact")} sortable/>
<Column 
  field="createdby"
  header={t("Created By")}
  body={(rowData) => rowData.createdby || 'System'}
/>
<Column 
  field="actionedbyname"
  header={t("Action By")}
  sortable
  body={(rowData) => rowData.actionedbyname || 'System'}
/>

  <Column
    header="Action"
    body={otherActionTemplate}
    headerStyle={{ textAlign: "right" }}
  />
</DataTable>

        <Dialog
          visible={showEditComplaintModal}
          className="quickview w-50"
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          modal
          onHide={() => setShowEditComplaintModal(false)}
        >
          <UpdateComplaintDataTable
            isUpdate={true}
            handleOnSuccess={handleOnSuccess}
            updateComplaintInfo={updateComplaintInfo ?? {} as complaintmodel}
            oldUserList={allComplaints} updatedData={undefined}          />
        </Dialog>

       <Dialog
  visible={showInvoiceModal}
  style={{ width: '80vw' }}
  modal
  onHide={() => setShowInvoiceModal(false)}
  header="Invoice Details"
  className="invoice-dialog"
>
  {selectedInvoice ? (
    <ComplaintInvoice invoiceData={selectedInvoice} />
  ) : (
    <div>Loading invoice data...</div>
  )}
</Dialog>

      </div>
    </div>
  );
};

export default ViewallComplaintsDatatable;